import { IS_CHINA_SITE } from './analytics/constants';

const { pages } = require('../constants/pages/page-config');

export const chinaSiteURL = 'https://perpetua.com.cn';

export const languageToNames = {
  'en-US': 'English',
  de: 'Deutsch',
  es: 'Español',
  ja: '日本語',
  'zh-CN': '简体中文',
};

export interface LanguageObject {
  language: string;
  slug?: string;
  languageCode: string;
  localized?: boolean;
  pageType?: string;
}

export const addLanguagesWithNames = (languages: any) => {
  return languages?.map((lng: any, i: number) => {
    if (lng?.language) {
      return {
        language: languageToNames[lng?.language],
        languageCode: lng.language,
        slug: lng?.url,
        localized: true,
        pageType: 'blog',
      };
    } else {
      return {
        language: languageToNames[lng],
        languageCode: lng,
        localized: true,
      };
    }
  });
};

export const getLanguagesFromPath = (originalPath: string) => {
  const path = originalPath.replace(/\//g, '');
  const found =
    path === ''
      ? pages?.find(page => page && page.matchPath === '/')
      : pages?.find(page => page && page.matchPath === `/:lang?/${path}`);

  let languages = found?.languages;
  if (found?.includeInChina) {
    languages = [...languages, 'zh-CN'];
  }

  return languages;
};

export const getLocalizedPath = (lng: LanguageObject, originalPath: string) => {
  const perpetua_home = IS_CHINA_SITE ? 'https://perpetua.io' : '';

  if (!lng.localized) {
    return lng.languageCode === 'en-US'
      ? perpetua_home + '/'
      : lng.languageCode === 'zh-CN'
      ? chinaSiteURL
      : `${perpetua_home}/${lng.languageCode}`;
  }

  if (lng.slug) {
    if (lng.languageCode === 'zh-CN') {
      return `${chinaSiteURL + lng.slug}`;
    } else if (lng.languageCode !== 'en-US' && lng.languageCode !== 'zh-CN') {
      return `${perpetua_home}/${lng.languageCode + lng.slug}`;
    } else {
      return perpetua_home + lng.slug;
    }
  } else {
    if (lng.languageCode === 'en-US') {
      return perpetua_home + originalPath;
    } else if (lng.languageCode === 'zh-CN') {
      return `${chinaSiteURL + originalPath}`;
    } else {
      return `${perpetua_home}/${lng.languageCode + originalPath}`;
    }
  }
};
